enum ActionTypes {
  LOAD_BACK_OFFICE_DEVICE_MAP_POINTS_REQUEST = 'LOAD_BACK_OFFICE_DEVICE_MAP_POINTS_REQUEST',
  LOAD_BACK_OFFICE_DEVICE_MAP_POINTS_SUCCESS = 'LOAD_BACK_OFFICE_DEVICE_MAP_POINTS_SUCCESS',
  LOAD_BACK_OFFICE_DEVICE_MAP_POINTS_FAILURE = 'LOAD_BACK_OFFICE_DEVICE_MAP_POINTS_FAILURE',

  SET_BACK_OFFICE_DEVICE_MAP_POINTS = 'SET_BACK_OFFICE_DEVICE_MAP_POINTS'
}

export default ActionTypes;
